


























import { NewsRenderModel, TextContent, Languages } from "@/services/news/types";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import moment from "moment";

@Component
export default class TextRender extends Vue {
    @Prop() private news!: NewsRenderModel;
    @Prop() private active!: boolean;

    reload = false;
    reloadComponent = 0;
    languages = Languages;

    // lifecycle hooks
    created() {
    }

    @Watch("active", { immediate: true, deep: true })
    onActiveChange(value: number) {
        if (value !== 0 && this.renderModel.duration) {
            return setTimeout(
                this.setNextNews,
                this.renderModel.duration * 1000
            );
        }
    }

    get renderModel(): TextContent {
        return this.news.content as TextContent;
    }

    get date() {
        const lang = this.languages.find(x => x.text === this.renderModel.language.toLowerCase());
        const locale = lang ? lang.code.toLowerCase() : "en";
        moment.locale(locale); // Ensure locale is properly set

        if (locale === "da") {
            return moment(this.news.publishDate).format("[d.] D. MMMM YYYY"); // Danish format: "d. 15. december 2022"
        } else if (locale === "sv") {
            return moment(this.news.publishDate).format("YYYY-MM-DD"); // Swedish format: "2025-05-27"
        } else {
            return moment(this.news.publishDate).format("MMMM Do, YYYY"); // English format: "December 15th, 2022"
        }
    }

    setNextNews() {
        this.$emit("setNextNews");
    }

    navigateTo(url: string) {
        window.open(url);
    }
}
